var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowStudentGuy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4962",
    "data-name": "Group 4962",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 579.727,
    height: 800,
    viewBox: "0 0 579.727 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1781",
    "data-name": "Rectangle 1781",
    width: 579.727,
    height: 800,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M78.595,550.948,29.432,726.371H445.9l-34.4-200a77.024,77.024,0,0,1,15.36-60.576,237.726,237.726,0,0,0,50.7-153.306c-3.207-127.333-107.9-230.824-235.257-232.641C108.813,77.946,0,185.588,0,318.646A237.784,237.784,0,0,0,61.8,478.87a76.554,76.554,0,0,1,16.79,72.078",
    transform: "translate(0 73.628)",
    fill: "#f2af0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M92.092,234.37a37.409,37.409,0,0,1-4.485-.269c-29.27-3.518-48.965-40.658-43.905-82.787a5.772,5.772,0,0,1,11.461,1.375c-4.3,35.814,10.869,67.195,33.82,69.956,23.005,2.745,45.128-24.137,49.432-59.951a5.771,5.771,0,0,1,11.459,1.378c-4.806,39.972-30.195,70.3-57.783,70.3",
    transform: "translate(39.578 134.876)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M180.378,243.266a38.6,38.6,0,0,1-4.629-.279c-14.622-1.755-27.215-11.642-35.455-27.838-7.851-15.433-10.854-34.947-8.449-54.951a5.771,5.771,0,0,1,11.459,1.378c-2.134,17.755.45,34.922,7.276,48.338,6.44,12.657,15.865,20.331,26.544,21.615s21.65-3.943,30.908-14.71c9.81-11.417,16.388-27.484,18.522-45.239a5.77,5.77,0,0,1,11.457,1.376c-2.4,20-9.941,38.252-21.227,51.385-10.59,12.324-23.368,18.922-36.408,18.924",
    transform: "translate(120.867 143.074)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M152.33,258.293c-.921,0-1.845-.013-2.78-.04-50.857-1.567-77.03-45.128-78.12-46.981a5.77,5.77,0,0,1,9.948-5.85c.957,1.63,23.964,39.92,68.523,41.293,36.744,1.25,60.19-23.653,64.523-28.632a5.772,5.772,0,0,1,8.708,7.578c-4.825,5.54-30.487,32.633-70.8,32.633",
    transform: "translate(65.151 186.853)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M491.109,68.208,511.044,30.42a6.2,6.2,0,0,0,.154-5.481l-1.476-2.826L466.9,12.661A6.232,6.232,0,0,0,461.583,14l-2.3,2.167,2.315,45.6a6.11,6.11,0,0,0,1.613,3.745,18.9,18.9,0,0,0-9.154,12.334v0a18.985,18.985,0,0,0,8.928,20.381,69.7,69.7,0,0,1-135.68-31.821L404.1,83.366a5.675,5.675,0,0,0,1.248.136,5.771,5.771,0,0,0,1.24-11.407L321.46,53.3l0,0L168.514,19.528,80.7.138a5.771,5.771,0,1,0-2.486,11.271l85.123,18.8L131.46,174.572,287.1,208.932,314.405,85.256a81.234,81.234,0,0,0,159.827,15.567,18.949,18.949,0,0,0,14.416-29.1c-.179-.281-.417-.506-.607-.775a6.086,6.086,0,0,0,3.068-2.741m-11.2,15.354a7.468,7.468,0,1,1-1-5.629,7.467,7.467,0,0,1,1,5.629",
    transform: "translate(67.964 0)",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStudentGuy);
export default __webpack_public_path__ + "static/media/yellow_student_guy.4b7c49b88a11204169f4342f63ebe8ef.svg";
export { ForwardRef as ReactComponent };